module.exports = __webpack_public_path__ + "fonts/Montserrat-Medium.f477392.woff";